import React from 'react';
import IframeResizer from "iframe-resizer-react";

const IframeResizerCellPlugin = {
  Renderer: ({data}) => {
    const {url} = data
    return <IframeResizer
      log
      src={url}
      style={{width: '1px', minWidth: '100%'}}
      frameBorder="0"
      // scrolling="no"
      allow="autoplay"
      sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation"
      allowFullScreen
    />
  },
  id: 'iframe-resizer-cell-plugin',
  title: 'Iframe Resizer',
  description: 'Iframe which is automatically resized.',
  version: 2,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        url: {
          type: 'string',
          default: 'https://flave.at',
        },
      },
      required: ['url'],
    },
  },
}

export default IframeResizerCellPlugin